module.exports = __webpack_public_path__ + "media/images/fr_ca/altruism-segment-5d08e4e8806f7babe44020535f3b580b.jpg";